export default "__VITE_ASSET__CVfRlAEq__"